import './multimedia-gallery.scss';
import Splide from '@splidejs/splide';
import { Translations } from '../utils';

export class MultimediaGallery {
  constructor() {
    this.init();
  }

  init() {
    const mainEl = document.querySelector('#gallery-main');
    const thumbsEl = document.querySelector('#gallery-thumbs');

    // Se uno dei due non esiste, esci
    if (!mainEl || !thumbsEl) return;
    const main = new Splide(mainEl, {
      type: 'fade',
      pagination: false,
      arrows: true,
      cover: true,
      i18n: Translations.getSplideI18n(),
    });

    const thumbs = new Splide(thumbsEl, {
      fixedWidth: 130,
      fixedHeight: 88,
      gap: 20,
      rewind: true,
      pagination: false,
      isNavigation: true,
      focus: 'center',
      arrows: false,
      breakpoints: {
        767: {
          fixedWidth: 101,
          fixedHeight: 67,
          gap: 8,
        },
      },
      i18n: Translations.getSplideI18n(),
    });

    main.sync(thumbs);

    main.mount();
    thumbs.mount();

    this.bindExternalArrows(main);
    this.bindDownload(main);
  }

  bindDownload(splide) {
    const btn = document.querySelector('.multimedia-gallery__download');

    if (!btn) return;

    btn.addEventListener('click', () => {
      const slideObj = splide.Components.Slides.getAt(splide.index);

      if (!slideObj) return;
      if (!slideObj.slide) return;

      const img = slideObj.slide.querySelector('img');

      if (!img) return;

      window.open(img.src, '_blank');
    });
  }

  bindExternalArrows() {
    // metodo placeholder per evitare errori
  }
}
